import moment from 'moment';

const generateFormattedDate = (dateTimeString = '', dateFormat = '') => {
  return dateTimeString ? moment(dateTimeString).format(dateFormat) : '';
};

const dateFormatterHelpers = {
  generateFormattedDate,
};

export default dateFormatterHelpers;
